import { FieldValues, Path, UseFormSetError } from 'react-hook-form'

const FALLBACK_ERROR_MESSAGE = 'There was a problem with your submission.'

type ZodLikeError = {
  path: string[]
  message: string
}
const isZodError = (e: unknown): e is ZodLikeError[] => Array.isArray(e) && 'path' in e[0]

export function processFormError<TFieldValues extends FieldValues>(
  setError: UseFormSetError<TFieldValues>,
  e: unknown,
  messages?: { genericMessage?: string; fieldLevelMessage?: string },
) {
  if (e instanceof Error) {
    try {
      const errors = JSON.parse(e.message)
      if (isZodError(errors)) {
        errors.map((e) => {
          setError(e.path.filter((p) => p !== 'values').join('.') as Path<TFieldValues>, {
            message: e.message,
          })
        })
        return
      } else {
        setError('root', { message: e.message })
        return
      }
    } catch (_) {
      setError('root', { message: e.message })
      return
    }
  }

  if (
    typeof e === 'object' &&
    e &&
    'errors' in e &&
    Array.isArray(e?.errors) &&
    e.errors.length > 0
  ) {
    const error = e.errors[0]
    if (typeof error === 'object' && 'message' in error) {
      setError('root', { message: error.message })
      return
    }
  }
  console.error('Unhandled form error', e)
  setError('root', { message: messages?.genericMessage || FALLBACK_ERROR_MESSAGE })
}
